import { render } from "./dashboard-stats.html?vue&type=template&id=72a76757&ts=true&external"
import script from "./dashboard-stats.ts?vue&type=script&lang=ts&external"
export * from "./dashboard-stats.ts?vue&type=script&lang=ts&external"

import "./dashboard-stats.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__